export default "__VITE_ASSET__5479e7a1__"